export default "__VITE_ASSET__e20005f4__"